export const SECTOR_INSIGHTS = [
    { title: 'Market Size', key: 'marketSize' },
    { title: 'Industry CAGR', key: 'industryCagr' },
    { title: 'Sector Risk', key: 'sectorRisks', isRiskIndicator: true },
    { title: 'Market Growth', key: 'marketGrowth' },
];

export const ICON_STYLES = {
    container: {
        marginRight: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row' as const,
    },
    icon: {
        width: '12px',
        height: '12px',
    },
    arrowIcon: {
        width: '14px',
        height: '14px',
    },
};
